<template>
  <div>
    <div class="">
      <div :class="infiniteList ? '' : 'items-list-container'">
        <div
          v-if="value.length > 0"
          class="pb-1 px-2 pt-2 forms-list d-flex flex-wrap"
        >
          <div
            class="filter-value border mr-1 mb-1 rounded bg-primary text-white"
            v-for="(valueItem, valueItemIndex) in value"
            :key="valueItem.value"
          >
            <div class="pr-4">
              {{ valueItem.label }}
            </div>
            <span
              class="filter-value-delete hover-pointer"
              @click="removeItem(valueItemIndex)"
              >X</span
            >
          </div>
        </div>
      </div>
      <div
        class="item-select-container bg-light-gray"
        :class="fullWidth ? '' : 'py-2 px-3'"
      >
        <v-select
          class="multiple-selector"
          v-model="selected"
          :placeholder="placeholder"
          :options="filteredOptions"
          @search="search"
          :filterable="!async"
        >
          <template #open-indicator>
            <span></span>
          </template>
        </v-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultipleSelectSidebarFilter",
  props: [
    "options",
    "value",
    "fullWidth",
    "placeholder",
    "infiniteList",
    "async"
  ],
  methods: {
    removeItem(itemIndex) {
      const newValue = [...this.value];
      newValue.splice(itemIndex, 1);
      this.$emit("input", newValue);
    },
    search(search, loading) {
      this.$emit("search", { search, loading });
    }
  },
  computed: {
    selected: {
      get() {
        return [];
      },
      set(newValue) {
        if (newValue) {
          const newListValue = [...this.value];
          newListValue.push(newValue);
          this.$emit("input", newListValue);
        }
      }
    },
    filteredOptions() {
      const valueValues = this.value ? this.value.map(v => v.value) : [];
      return this.options.filter(o => valueValues.indexOf(o.value) == -1);
    }
  }
};
</script>

<style scoped>
.forms-list {
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-bottom-width: 0px !important;
}
.items-list-container {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-value {
  position: relative;
  color: #a6a6a6;
  font-size: 12px;
  padding: 2px 5px;
}
.filter-value-delete {
  position: absolute;
  top: 3px;
  right: 7px;
  font-weight: bold;
  font-size: 10px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.multiple-selector.v-select .vs__dropdown-toggle {
  min-height: calc(1.5em + 0.75rem + -3px);
}
.multiple-selector .vs__dropdown-toggle {
  border-radius: 0px;
}
</style>
